import { useEffect } from 'react';
import swal from 'sweetalert';

// I terminali usano lettori di codici a barre: se nessun input ha il focus la scansione
// va persa. Appena il focus non e' piu' su un input (click fuori, swal chiuso, ...) lo si
// riporta sul campo indicato. Con uno swal aperto non si tocca niente: il focus serve a lui.
const CHECK_MS = 250;

export default function useKeepInputFocus(inputRef) {
    useEffect(() => {
        const keepFocus = () => {
            if (swal.getState().isOpen) return;
            const active = document.activeElement;
            if (active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA')) return;
            inputRef.current?.focus();
        };
        // focusout per reagire subito al click fuori; il controllo periodico copre i casi
        // senza un evento affidabile (chiusura dello swal, elemento col focus rimosso)
        const onFocusOut = () => setTimeout(keepFocus, 0);

        keepFocus();
        document.addEventListener('focusout', onFocusOut);
        const interval = setInterval(keepFocus, CHECK_MS);

        return () => {
            document.removeEventListener('focusout', onFocusOut);
            clearInterval(interval);
        };
    }, [inputRef]);
}
